module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AS2sG2/tc-custom/9781460318713.jpg?1740629675648",
      "alt": "This image is the cover for the book Mission: Cavanaugh Baby, Cavanaugh Justice"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mission: Cavanaugh Baby, Cavanaugh Justice\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("An Entertainment Weekly Top 10 Romance Author")]), _c('br'), _c('br'), _c('b', [_vm._v("From "), _c('i', [_vm._v("USA TODAY")]), _vm._v(" bestselling author Marie Ferrarella comes another Cavanaugh Justice book, and this time a baby's in jeopardy…")]), _c('br'), _c('br'), _vm._v("The only things Ashley St. James has ever allowed herself to love are her dogs. A child of the foster-care system, she never even knew her own birthday. When a dog in distress leads her to a brutally butchered woman whose baby was stolen, Ashley has a purpose—so she teams up with cop Shane Cavanaugh."), _c('br'), _c('br'), _vm._v("Losing his fiancée only ripened Shane's thirst for justice. But the closer he gets to Ashley, the more he wants to erase the tears she hasn't managed to dry. If they can find the missing baby and nab a psychotic killer first."), _c('br'), _c('br'), _c('b', [_vm._v("If you love this read from Marie Ferrarella, unearth more scintillating secrets of the Adair family in CARRYING HIS SECRET, her 250th Harlequin book! Available only from Harlequin Romantic Suspense!")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marie Ferrarella\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("This USA TODAY bestselling and RITA ® Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0